import React from 'react';
import useComponentDidMount from 'Hooks/useComponentDidMount';
import MessageList from 'Components/ComponentLibrary/Organisms/MessageList';
import usePrevious from 'Hooks/usePrevious';
import { useCommentLayoutContext } from '../../../CommentLayoutProvider';

const MessageListWrapper = () => {
  const {
    endRef,
    scrollToBottomOfMessages,
    inflightMessage,
    showCommentLayout,
    messageResourceList,
  } = useCommentLayoutContext();
  const prevShowCommentLayout = usePrevious(showCommentLayout);
  const prevInflightMessage = usePrevious(inflightMessage);

  useComponentDidMount(() => {
    scrollToBottomOfMessages();
  });

  // Scroll to bottom when messages are opened
  React.useEffect(() => {
    if (showCommentLayout && !prevShowCommentLayout) {
      scrollToBottomOfMessages();
    }
  }, [showCommentLayout, prevShowCommentLayout]);

  // Scroll to bottom when a new message is added
  React.useEffect(() => {
    if (inflightMessage !== null && prevInflightMessage === null) {
      scrollToBottomOfMessages({ isSmooth: true });
    }
  }, [inflightMessage, prevInflightMessage]);

  const messageResources = [
    ...messageResourceList,
    inflightMessage,
  ].filter((messageResource) => !!messageResource);

  return (
    <>
      <MessageList messageResources={messageResources} />
      <div ref={endRef} />
    </>
  );
};

export default MessageListWrapper;
